<template>
  <div
    class="card form-container"
    :style="formStyle"
  >
    <div
      v-if="hasHeader"
      :isBordered="isBordered"
      class="form-header"
    >
      <slot name="header">
        <div
          class="form-header-flex"
        >
          <div class="header-left">
            <slot name="header-left">
              <div>
                <div class="title">
                  <slot name="title" />
                </div>
                <div
                  name="subtitle"
                  class="subtitle"
                >
                  <slot name="subtitle" />
                </div>
              </div>
            </slot>
          </div>

          <div class="header-right">
            <slot name="header-right" />
          </div>
        </div>
      </slot>
    </div>

    <div class="form-content">
      <slot />
    </div>

    <div
      v-if="hasFooter"
      class="form-footer"
      :style="footerStyle"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Form",

  props: {
    isBordered: {
      type: Boolean,
      default: true
    },
    padding: {
      type: String,
      default: "20px"
    },
    footerFlex: {
      type: String,
      default: "flex-end",
      validator: function (value) {
        let validationResult =
          [
            "flex-end",
            "flex-start"
          ].indexOf(value) !== -1;

        if (!validationResult) {
          console.error(value);
        }

        return validationResult;
      }
    }
  },

  computed: {
    hasHeader() {
      return this.$slots["header-left"]
      || this.$slots["header-right"]
      || this.$slots["header"]
      || this.$slots["title"]
      || this.$slots["subtitle"];
    },

    hasFooter() {
      return this.$slots.footer;
    },

    footerStyle() {
      return {
        "justify-content": this.footerFlex
      };
    },

    formStyle() {
      return {
        "padding": this.padding
      };
    }
  }
};
</script>

<style scoped lang="scss">
.form-container {
  padding: 20px;
  font-family: 'Suisse Intl', serif;
  font-style: normal;
}

.form-header {
  font-size: 24px;
  line-height: 24px;

  margin-bottom: 15px;

  &[isBordered=true] {
    border-bottom: 1px solid var(--color-70);
    padding-bottom: 15px;
  }

  &-flex {
    display: flex;
    justify-content: space-between;
  }
}

.header-left {
  font-size: 20px;
  line-height: 1.1em;
}

.form-footer {
  display: flex;
  gap: 10px;

  margin-top: 20px;

  @media screen and (max-width:460px) {
    flex-direction: column;
  }
}

.title {
  font-size: 24px;
  line-height: 1.1em;
  color: var(--text-color);
}

.subtitle {
  font-weight: 450;
  font-size: 12px;
  color: var(--color-60);
}
</style>